let config = {
  emailjs: {
    serviceID: "service_fv8254c",
    templateID: "template_degd5hj",
    userID: "user_iMjKxiOc7DoaZ2cZLnWHg"
  }
};

export default config;
